import { SVODStatusEvent } from '../analytics/analytics-events/constants';
import { setCookieValue } from "../functions/persistent";
import { getToken } from "../functions/auth";
import { initCap } from "../functions/utils";
import Logger from '../functions/logging';
import settings from "../libs/config";
import * as TargetProcess from '../functions/targetProcess';
import * as codes from "../constants/feedbackCodes";
import { formatDuration } from '../functions/time';

import { CLOSE_STUDY_CODE, FILTERED_REGISTRATION_CODE, QUOTA_FULL_CODE, UNKNOWN_CODE } from '../constants/screenCodes';
import { RESTRICTED_AGE } from '../constants/registrationConstants';

const PARTNERS_WITH_AGE_EXEMPTIONS = ['material'];

export const areObjectsTheSame = (object1, object2) => {
	if ((Object.keys(object1).length !== Object.keys(object2).length) ||
		!Object.keys(object1).length || !Object.keys(object2).length) {
		return false;
	}
	for (let key in object1) {
		if (JSON.stringify(object1[key]) !== JSON.stringify(object2[key])) {
			return false;
		}
	}
	return true;
};

export const getPanelSegmentScreenCode = (panelSegmentResult) => {
	if (!panelSegmentResult.active) {
		return CLOSE_STUDY_CODE;
	}

	if (panelSegmentResult.quotaFiltered || !panelSegmentResult.eligible) {
		return FILTERED_REGISTRATION_CODE;
	}

	if (panelSegmentResult.quotaFull || !panelSegmentResult.fitsQuota) {
		return QUOTA_FULL_CODE;
	}

	return UNKNOWN_CODE;
};

export const randomString = (stringLength) => {
	// http://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
	let possible = 'abcdef0123456789'; // 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	let randomString = Array.apply(null, new Array(stringLength)).map(function () {
		return possible[Math.floor(Math.random() * possible.length)];
	}).join('');

	return randomString;
};

export const sortArrayofObjects = (array, param) => {
	if (array && array.length) {
		const compare = (objA, objB) => {
			const bandA = objA[param];
			const bandB = objB[param];

			let comparison = 0;
			if (bandA > bandB) {
				comparison = 1;
			} else if (bandA < bandB) {
				comparison = -1;
			}
			return comparison;
		};
		array = array.sort(compare);
	}
	return array;
};

// export const deepCloneArray = (array) => {
// 	return $.extend(true, [], array);
// };

// export const deepCloneObject = (object) => {
// 	return $.extend(true, {}, object);
// };

export const getEventName = (location) => {
	if (location instanceof Object) {
		return SVODStatusEvent[`SVODPLAYER_FSVIDEO`];
	} else {
		return SVODStatusEvent[`SVODPLAYER_${location}`];
	}
}; 

export const getViewerMetadata = (currentUser, group) => {
	if (group &&
		group._id &&
		currentUser &&
		currentUser.viewer_metadata &&
		currentUser.viewer_metadata.length
	) {
		for (let i = 0; i < currentUser.viewer_metadata.length; i++) {
			let metadata = currentUser.viewer_metadata[i];
			if (metadata.user_id === currentUser.user_id &&
				metadata.group_id.valueOf() === group._id.valueOf()
			) {
				return metadata;
			}
		}
	}
	return null;
};

export const setViewerCookies = (targetParams, fetchedGroup, fetchedEpisode, currentUser, viewerMetadata) => {
	let ps = viewerMetadata && viewerMetadata.reelchat && viewerMetadata.reelchat.moderated_panel_segment ? 
		viewerMetadata.reelchat.moderated_panel_segment
		:
		targetParams.ps;

	setCookieValue("pil_gid", targetParams.gid, 1, true);
	setCookieValue("pil_ps", ps, 1, true);
	setCookieValue("pil_episode_id", (fetchedEpisode ? fetchedEpisode._id.valueOf() : ""), 1, true);
	setCookieValue("pil_user_id", currentUser.user_id, 1, true);
	setCookieValue("pil_portalToken", getToken(), 1, true);
	setCookieValue("pil_lang", targetParams.lang, 1, true);
	setCookieValue("pil_test", targetParams.test, 1, true);
	setCookieValue("pil_age", currentUser.age, 1, true);
	setCookieValue("pil_city", initCap(currentUser.city), 1, true);
	setCookieValue("pil_state", currentUser.state, 1, true);
	setCookieValue("pil_zip", currentUser.zip, 1, true);
	setCookieValue("pil_country", initCap(currentUser.country), 1, true);
	setCookieValue("pil_gender", currentUser.gender ? currentUser.gender.toUpperCase() : "", 1, true);
	setCookieValue("pil_partner", targetParams.partner ? targetParams.partner : "", 1, true);
	setCookieValue("pil_partnerName", targetParams.partnerName ? targetParams.partnerName : "", 1, true);
};

export const getRedirectToReelChat = (targetParams, psIndex) => {
	Logger.log("redirectToReelChat() isModerated", targetParams);

	let url = settings.moderated_host + "?gid=" + targetParams.gid;

	if (psIndex || psIndex === 0 || (targetParams && targetParams.ps)) {
		url += '&ps=' + (psIndex || targetParams.ps) + '&psreq=1';
	}

	url += targetParams.demo ? "&demo=" + targetParams.demo : "";
	url += targetParams.audio ? "&audio=" + targetParams.audio : "";
	url += targetParams.wait ? "&wait=" + targetParams.wait : "";

	return url;
};

export const getParamsFromUrl = (url) => {
	let paramsObject = { url };
	if (url && url.indexOf('?') !== -1) {
		const paramsList = url.split('?')[1].split('&');

		paramsList.forEach(param => {
			const paramName = param.split('=')[0];
			const paramValue = param.split('=')[1];
			paramsObject[paramName] = paramValue;
		});
	}
	return paramsObject;
};

export const isTesterFromUrl = (url) => {
	let urlParams = url ? new URLSearchParams(url) : new URLSearchParams(window.location.search);
	const TEST_PARAM = "test";
	return urlParams.has(TEST_PARAM) && parseInt(urlParams.get(TEST_PARAM)) === 1;
};

export const buildProcessTargetUrl = (paramsObject, overridePanelSegment) => {
	Logger.log("buildProcessTargetUrl()", paramsObject, settings.portal_url);
	const excludedParams = ['fakeUser', 'url', 'provider', 'thirdPartyUrl'];
	let targetUrl = settings.portal_url + '/process-target';

	if (paramsObject.ps 
		&& paramsObject.url 
		&& overridePanelSegment
	) {
		targetUrl += paramsObject.url;
		targetUrl = targetUrl.replace(/&ps=\d*/ig, '');
		targetUrl = targetUrl.replace(/&psreq=1/ig, '');

		targetUrl += paramsObject.lang ? '&lang=' + paramsObject.lang : '';
		targetUrl += paramsObject.ps ? '&ps=' + paramsObject.ps : '';
		targetUrl += paramsObject.psreq ? '&psreq=1' : '';
		targetUrl += paramsObject.psselected ? '&psselected=1' : '';
	}
	else {
		targetUrl += '?';
		for (let param in paramsObject) {
			if (!excludedParams.includes(param)) {
				targetUrl += '&' + param + '=' + paramsObject[param];
			}
		}
	}

	return targetUrl;
};

export const isSVODPanelSegment = (group, psIndex) => {
	if (group 
		&& group.panel_segment
		&& group.panel_segment[psIndex]
		&& group.panel_segment[psIndex].svod_id
	) {
		return true;
	}
	return false;
};

export const isGroupSurveyOnly = (group) => {
	return group && group.research_env === 'survey';
};

export const isAgeRestricted = (targetParams, age) => {
	if (age < RESTRICTED_AGE
		&& (!targetParams || !PARTNERS_WITH_AGE_EXEMPTIONS.includes(targetParams.partner))
	) {
		return true;
	}
	return false;
};

export const isEthnicityFieldEnabled = (targetParams) => {
	return !targetParams || (targetParams.eth !== '0');
};

export const checkUserAcceptedDisclaimers = (authedUser, group_id, disclaimer) => {
	if (authedUser && authedUser.viewer_metadata && authedUser.viewer_metadata.length) {
		for (let i = 0; i < authedUser.viewer_metadata.length; i++) {
			let metadata = authedUser.viewer_metadata[i];

			if (metadata.group_id === group_id
				&& metadata.accepted_disclaimers
				&& metadata.accepted_disclaimers.includes(disclaimer)
			) {
				return true;
			}

			if (metadata.group_id === group_id
				&& metadata.disclaimers
				&& metadata.disclaimers[disclaimer]
			) {
				return true;
			}
		}
	}
	return false;
};

export const convertToMinutes = (seconds) => {
	let lengthString = "";
	if (seconds) lengthString = `${Math.ceil(seconds/60)} min`;

	return lengthString;
};

export const mongoIdToString = (_id) => {
	return _id ? (_id.$oid ? _id.$oid : _id.$id) : null;
};

export const checkUpdatingViewerMetadata = (targetParams) => {
	return targetParams
		&& (
			targetParams.guidance
			|| targetParams.afc
			|| targetParams.tc
			|| targetParams.rch
			|| isQualtricsPartner(targetParams.partner)
		);
};

export const returnStudyRedirects = (group, ps) => {
	if (group
		&& group.panel_segment
		&& group.panel_segment.length
		&& (ps || ps == 0)
		&& group.panel_segment[ps]
		&& group.panel_segment[ps].redirects
	) {
		return group.panel_segment[ps].redirects;
	}

	return null;
};

export const setupRedirectsFromParams = (params) => { 
	let paramsObject = TargetProcess.decodeRedirects(params);

	paramsObject = paramsObject.partner ? TargetProcess.partnerIdReplace(paramsObject) : paramsObject;
	paramsObject = paramsObject.publisher ? TargetProcess.publisherReplace(paramsObject) : paramsObject;

	return paramsObject;
};

export const isPilotlyDevelopment = (appEnvironment) => {
	const productionEnvironment = ['staging', 'production'];
	return !productionEnvironment.includes(appEnvironment);
};

export const getRowAssets = (rows) => {
	let videos = {};
	let rowLabels = [];

	if (rows) {
		for (let i = 0; i < rows.length; i++) {
			const { id, label, display_type, assets } = rows[i];
			let genre = `${label}_${id}`;

			if (display_type.includes("billboard")) {
				genre = `Billboard_${id}`;
			}
			else if (display_type === "highlight") {
				genre = `Highlight_${id}`;
			}
			else if (display_type === "poster") {
				genre = `Poster_${id}`;
			}

			let vidObj = {};
			for (let j = 0; j < assets.length; j++) {
				vidObj[assets[j]._id.valueOf()] = assets[j];
			}

			rowLabels.push(genre);
			videos[genre] = vidObj;
		}
	}

	return { videos, rowLabels };
};

export const returnQuestionTrackerInfo = (answeredQuestions) => {
	let pathTracker = [];
	let answerTracker = [];
	answeredQuestions.forEach((question) => {
		answerTracker = answerTracker.concat(question.response);
		pathTracker = pathTracker.concat(question.paths);
	});

	return { answerTracker, pathTracker };
};

export const returnSVODAssetMetadata = (asset) => { 
	let metadata = "";
	if (asset && asset.content && asset.content.genres) metadata += asset.content.genres.join(" · ");
	if (asset && asset.content && asset.content.mpaa) metadata += `${metadata ? " · " : ""}${asset.content.mpaa.label}`;
	if (asset && asset.video && asset.video.duration) metadata += `${metadata ? " · " : ""}${formatDuration(asset.video.duration, false, false, false, true, true)}`;
	if (asset && asset.content && asset.content.year) metadata += `${metadata ? " · " : ""}${asset.content.year}`;

	return metadata;
};

export const isFirefoxBrowser = (browser) => { 
	return browser && browser.toLowerCase().includes("firefox");
};

export const returnSimpleBrowserText = (browser) => {
	return browser ? browser.replace(/ .*/g, "") : "";
};

export const isQualtricsPartner = (partner) => {
	return partner && partner.toLowerCase().includes("qualtrics");
};

export const returnRedirectUrl = (feedbackType, targetParams) => {
	switch (feedbackType) {
		case codes.THANK_YOU: {
			// redirect using redir url
			Logger.log("HELPER: returnRedirectUrl() thankyou", targetParams.redir);
			return targetParams.redir;
		}
		case codes.DATA_QUALITY: {
			// redirect using dq url
			Logger.log("HELPER: returnRedirectUrl() dataquality", targetParams.dq);
			return targetParams.dq;
		}
		case codes.TERMINATE: {
			// redirect using err url
			Logger.log("HELPER: returnRedirectUrl() terminate");
			return targetParams.err;
		}
		case codes.OVER_QUOTA: {
			// redirect user oq url
			Logger.log("HELPER: returnRedirectUrl() overquota", targetParams.oq);
			return targetParams.oq;
		}
		case codes.INVALID_URL: {
			// redirect using err url
			Logger.log("HELPER: returnRedirectUrl() invalidUrl", targetParams.err);
			return targetParams.err;
		}
		default: {
			Logger.log("HELPER: returnRedirectUrl() Missing type");
			return null;
		}
	}
};

export const isReelChatStudy = (targetParams) => {
	return targetParams && targetParams.rch === '1';
};


// WEBPACK FOOTER //
// ./src/functions/helpers.js